document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('.search-input');
  const searchResults = document.querySelector('.search-results');

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      const query = searchInput.value;

      if (query.length > 0) {
        fetch(`/search/suggest?q=${query}&resources[type]=product,collection,query&resources[limit]=25&section_id=predictive-search`)
          .then(response => response.text())
          .then(html => {
            searchResults.innerHTML = html;
          });
      } else {
        searchResults.innerHTML = '';
      }
    });
  }
searchInput.addEventListener('focus', function () {
  if (searchInput.value.trim().length === 0) {
    searchResults.innerHTML = ''; // Clear results if no query
  }
});
searchInput.addEventListener('focus', function () {
  searchInput.value = ''; // Clear the input field
});

});

$(document).ready(function(){
  $(document).on('click', '.tab-button', function(){
    $('.predictive-search-results .tab-button, .predictive-search-results .tab-content').removeClass('active');
    $(this).addClass('active');
    $('#' + $(this).data('tab')).addClass('active');
  });

  $('.btn-search').on('click', function(){
    $('.search_container').toggleClass('hide');
  });

  $('.btn-search-close').on('click', function(){
    $('.search_container').addClass('hide');
  });
});